import React from 'react';
import styles from './AuthTitle.css';

type Props = {
  title?: string;
  subTitle?: string;
};

class AuthTitle extends React.PureComponent<Props> {
  render() {
    return (
      <div className={styles.border}>
        <h2 className={styles.title}>{this.props.title}</h2>
        {this.props.subTitle && <p>{this.props.subTitle}</p>}
      </div>
    );
  }
}

export default AuthTitle;
